import { useRef, useState } from "react";
import * as React from "react";
import { createContainer } from "unstated-next";

export interface IKeyboardContainer {
  inputName: string;
  setInputName: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  keyboardRef: React.MutableRefObject<undefined> | undefined;
  onInputFieldFocus: (name: string) => void;
  setInput: (inputValue: string) => void;
  getInputValue: (name: string) => string;
}

function useKeyboard(): IKeyboardContainer {
  const [inputName, setInputName] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const keyboardRef = useRef();

  const setInput = (inputValue: string) => {
    // @ts-ignore
    keyboardRef!.current.keyboard.setInput(inputName, inputValue);
  };

  const getInputValue = (name: string): string =>
    // @ts-ignore
    keyboardRef!.current.getInput(name).value;

  const onInputFieldFocus = (name: string) => {
    setIsOpen(true);
    setInputName(name);
  };

  return {
    inputName,
    setInputName,
    isOpen,
    setIsOpen,
    keyboardRef,
    onInputFieldFocus,
    setInput,
    getInputValue
  };
}

const KeyboardContainer = createContainer(useKeyboard);

export const KeyboardContainerProvider = KeyboardContainer.Provider;
export default KeyboardContainer;



// WEBPACK FOOTER //
// ./src/components/common/Keyboard/Keyboard.container.ts